import React from "react";
import { CARDS_INFO_KEY } from "../../../../../constants/cards";
import { getCardIdsFromAdditionalInfo } from "../../../../../utilites/card/getCardIdsFromAdditionalInfo";
import { isValidUrl } from "./isValidUrl";
export var MAX_FILES_COUNT = 15;
export var shouldDisableSubmit = function (state, opt) {
    var _a, _b;
    if (opt === void 0) { opt = {}; }
    var style = state.style, text = state.text, iframeLink = state.iframeLink, lessonPostDisabled = state.lessonPostDisabled, projectIds = state.projectIds, formId = state.formId, additionalInfo = state.additionalInfo, cardIds = state.cardIds, spVoteError = state.spVoteError, multiLoadGrouppedImg = state.multiLoadGrouppedImg, isMultipleFetchStart = state.isMultipleFetchStart, ratioError = state.ratioError, imageId = state.imageId, linkText = state.linkText, bigImageSrc = state.bigImageSrc, isLoading = state.isLoading, disablePosting = state.disablePosting;
    var isUpdate = opt.isUpdate, post = opt.post;
    var isMultiLoadDisabled = multiLoadGrouppedImg === null || multiLoadGrouppedImg === void 0 ? void 0 : multiLoadGrouppedImg.every(function (img) { return img.isUploaded; });
    var isMultipleLoadingStart = isMultipleFetchStart;
    if (isUpdate) {
        if (disablePosting)
            return true;
        switch (style) {
            case 'podcast':
                return (text === null || text === void 0 ? void 0 : text.length) === 0;
            case 'course_lesson':
                return lessonPostDisabled;
            case 'projects':
            case 'course_presentation':
                return (projectIds === null || projectIds === void 0 ? void 0 : projectIds.length) === 0;
            case 'products':
            case 'card':
                return !((_a = getCardIdsFromAdditionalInfo(additionalInfo, cardIds)) === null || _a === void 0 ? void 0 : _a.length);
            case 'slider':
            case 'tile':
                return ((multiLoadGrouppedImg === null || multiLoadGrouppedImg === void 0 ? void 0 : multiLoadGrouppedImg.length) < 2 || (multiLoadGrouppedImg === null || multiLoadGrouppedImg === void 0 ? void 0 : multiLoadGrouppedImg.length) > MAX_FILES_COUNT);
            case 'two_pictures':
                return ((multiLoadGrouppedImg === null || multiLoadGrouppedImg === void 0 ? void 0 : multiLoadGrouppedImg.length) !== 2 || !isMultiLoadDisabled);
            case 'normal_image':
                return (bigImageSrc === '' || text.length === 0);
            case 'normal_card':
                return (!(additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === CARDS_INFO_KEY; })) || text.length === 0);
            case 'forms':
                return false;
            case 'link':
                return (text === null || text === void 0 ? void 0 : text.length) === 0 || (linkText === null || linkText === void 0 ? void 0 : linkText.length) === 0 || !isValidUrl(linkText);
            default:
                return !!((text.length === 0 &&
                    post.attachments.length === 0) ||
                    isLoading);
        }
    }
    switch (style) {
        case 'podcast':
            return ((text === null || text === void 0 ? void 0 : text.length) === 0 && (iframeLink === null || iframeLink === void 0 ? void 0 : iframeLink.length) === 0);
        case 'course_lesson':
            return lessonPostDisabled;
        case 'projects':
        case 'course_presentation':
            return (projectIds === null || projectIds === void 0 ? void 0 : projectIds.length) === 0;
        case 'multiple':
            return (!isMultiLoadDisabled || isMultipleLoadingStart);
        case 'forms':
            return formId === '';
        case 'products':
        case 'card':
            return !((_b = getCardIdsFromAdditionalInfo(additionalInfo, cardIds)) === null || _b === void 0 ? void 0 : _b.length);
        case 'super-puper-vote':
        case 'slider':
        case 'tile':
        case 'two_pictures':
            return (!isMultiLoadDisabled ||
                isMultipleLoadingStart ||
                spVoteError ||
                (multiLoadGrouppedImg === null || multiLoadGrouppedImg === void 0 ? void 0 : multiLoadGrouppedImg.length) < 2 ||
                ((style === 'slider' || style === 'tile') && (multiLoadGrouppedImg === null || multiLoadGrouppedImg === void 0 ? void 0 : multiLoadGrouppedImg.length) > MAX_FILES_COUNT) ||
                (style === 'two_pictures' && ratioError));
        case 'as_cover':
            return (imageId === '');
        case 'normal_image':
            return (bigImageSrc === '' || text.length === 0);
        case 'normal_card':
            return (!(additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === CARDS_INFO_KEY; })) || text.length === 0);
        case 'link':
            return (text === null || text === void 0 ? void 0 : text.length) === 0 || (linkText === null || linkText === void 0 ? void 0 : linkText.length) === 0 || !isValidUrl(linkText);
        default:
            return !!((text.length === 0 && imageId === '') || isLoading);
    }
};
//# sourceMappingURL=shouldDisableSubmit.js.mapimport React from "react";
import { CARDS_INFO_KEY } from "../../../../../constants/cards";
import { getCardIdsFromAdditionalInfo } from "../../../../../utilites/card/getCardIdsFromAdditionalInfo";
import { isValidUrl } from "./isValidUrl";
export var MAX_FILES_COUNT = 15;
export var shouldDisableSubmit = function (state, opt) {
    var _a, _b;
    if (opt === void 0) { opt = {}; }
    var style = state.style, text = state.text, iframeLink = state.iframeLink, lessonPostDisabled = state.lessonPostDisabled, projectIds = state.projectIds, formId = state.formId, additionalInfo = state.additionalInfo, cardIds = state.cardIds, spVoteError = state.spVoteError, multiLoadGrouppedImg = state.multiLoadGrouppedImg, isMultipleFetchStart = state.isMultipleFetchStart, ratioError = state.ratioError, imageId = state.imageId, linkText = state.linkText, bigImageSrc = state.bigImageSrc, isLoading = state.isLoading, disablePosting = state.disablePosting;
    var isUpdate = opt.isUpdate, post = opt.post;
    var isMultiLoadDisabled = multiLoadGrouppedImg === null || multiLoadGrouppedImg === void 0 ? void 0 : multiLoadGrouppedImg.every(function (img) { return img.isUploaded; });
    var isMultipleLoadingStart = isMultipleFetchStart;
    if (isUpdate) {
        if (disablePosting)
            return true;
        switch (style) {
            case 'podcast':
                return (text === null || text === void 0 ? void 0 : text.length) === 0;
            case 'course_lesson':
                return lessonPostDisabled;
            case 'projects':
            case 'course_presentation':
                return (projectIds === null || projectIds === void 0 ? void 0 : projectIds.length) === 0;
            case 'products':
            case 'card':
                return !((_a = getCardIdsFromAdditionalInfo(additionalInfo, cardIds)) === null || _a === void 0 ? void 0 : _a.length);
            case 'slider':
            case 'tile':
                return ((multiLoadGrouppedImg === null || multiLoadGrouppedImg === void 0 ? void 0 : multiLoadGrouppedImg.length) < 2 || (multiLoadGrouppedImg === null || multiLoadGrouppedImg === void 0 ? void 0 : multiLoadGrouppedImg.length) > MAX_FILES_COUNT);
            case 'two_pictures':
                return ((multiLoadGrouppedImg === null || multiLoadGrouppedImg === void 0 ? void 0 : multiLoadGrouppedImg.length) !== 2 || !isMultiLoadDisabled);
            case 'normal_image':
                return (bigImageSrc === '' || text.length === 0);
            case 'normal_card':
                return (!(additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === CARDS_INFO_KEY; })) || text.length === 0);
            case 'forms':
                return false;
            case 'link':
                return (text === null || text === void 0 ? void 0 : text.length) === 0 || (linkText === null || linkText === void 0 ? void 0 : linkText.length) === 0 || !isValidUrl(linkText);
            default:
                return !!((text.length === 0 &&
                    post.attachments.length === 0) ||
                    isLoading);
        }
    }
    switch (style) {
        case 'podcast':
            return ((text === null || text === void 0 ? void 0 : text.length) === 0 && (iframeLink === null || iframeLink === void 0 ? void 0 : iframeLink.length) === 0);
        case 'course_lesson':
            return lessonPostDisabled;
        case 'projects':
        case 'course_presentation':
            return (projectIds === null || projectIds === void 0 ? void 0 : projectIds.length) === 0;
        case 'multiple':
            return (!isMultiLoadDisabled || isMultipleLoadingStart);
        case 'forms':
            return formId === '';
        case 'products':
        case 'card':
            return !((_b = getCardIdsFromAdditionalInfo(additionalInfo, cardIds)) === null || _b === void 0 ? void 0 : _b.length);
        case 'super-puper-vote':
        case 'slider':
        case 'tile':
        case 'two_pictures':
            return (!isMultiLoadDisabled ||
                isMultipleLoadingStart ||
                spVoteError ||
                (multiLoadGrouppedImg === null || multiLoadGrouppedImg === void 0 ? void 0 : multiLoadGrouppedImg.length) < 2 ||
                ((style === 'slider' || style === 'tile') && (multiLoadGrouppedImg === null || multiLoadGrouppedImg === void 0 ? void 0 : multiLoadGrouppedImg.length) > MAX_FILES_COUNT) ||
                (style === 'two_pictures' && ratioError));
        case 'as_cover':
            return (imageId === '');
        case 'normal_image':
            return (bigImageSrc === '' || text.length === 0);
        case 'normal_card':
            return (!(additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === CARDS_INFO_KEY; })) || text.length === 0);
        case 'link':
            return (text === null || text === void 0 ? void 0 : text.length) === 0 || (linkText === null || linkText === void 0 ? void 0 : linkText.length) === 0 || !isValidUrl(linkText);
        default:
            return !!((text.length === 0 && imageId === '') || isLoading);
    }
};
//# sourceMappingURL=shouldDisableSubmit.js.map